<template>
  <div class="folha-carregando-ancora">
    <div
      ref="overlay"
      v-show="ativo"
      class="loading-overlay folha-carregando"
      role="status"
      aria-live="polite"
      :aria-busy="ativo"
    >
      <div class="loading-card folha-carregando__card">
        <span class="spinner"></span>
        <span class="label">
          <span class="folha-carregando__titulo">{{ mensagem }}</span>
          <span v-if="detalhe" class="folha-carregando__detalhe">{{
            detalhe
          }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
// Spinner grande no centro da tela (mesmo visual do carregamento do ListagemBase). O overlay vai para a raiz do
// v-app (onde o Vuetify anexa os diálogos) para cobrir a tela inteira, inclusive diálogos, enquanto a operação
// estiver em andamento; a âncora fica no lugar do componente para o Vue continuar atualizando a árvore.
export default {
  name: "CarregandoFolha",
  props: {
    mensagem: { type: String, default: null },
    detalhe: { type: String, default: null },
  },
  computed: {
    ativo() {
      return !!this.mensagem;
    },
  },
  mounted() {
    (document.querySelector("[data-app]") || document.body).appendChild(
      this.$refs.overlay
    );
  },
  beforeDestroy() {
    const el = this.$refs.overlay;
    if (el && el.parentNode) el.parentNode.removeChild(el);
  },
};
</script>
<style>
.folha-carregando-ancora {
  display: none;
}

.loading-overlay.folha-carregando {
  backdrop-filter: blur(2px);
  background: rgba(243, 244, 246, 0.72);
  inset: 0;
  position: fixed;
  z-index: 9999;
}

.loading-overlay.folha-carregando .folha-carregando__card {
  gap: 24px;
  min-width: min(520px, calc(100vw - 32px));
  padding: 28px 30px;
}

.loading-overlay.folha-carregando .spinner {
  flex: 0 0 88px;
  height: 88px;
  width: 88px;
}

.loading-overlay.folha-carregando .spinner::before {
  border-width: 5px;
  height: 56px;
  width: 56px;
}

.loading-overlay.folha-carregando .spinner::after {
  height: 10px;
  width: 10px;
}

.folha-carregando__titulo {
  font-size: 1.1rem;
  overflow-wrap: anywhere;
}

.folha-carregando__detalhe {
  color: #667085;
  font-size: 0.85rem;
  font-weight: 500;
}
</style>
